<template>
 <div class="login">
     <div class="login-box">
        <div class="left-box">
            <h2 class="tit">场租宝</h2>
            <p class="av-txt">发需求，马上定</p>
        </div>
        <div class="right-box">
            <div class="logo">
                <img src="../../assets/images/logo.png" alt="">
            </div>
            <div class="input-box">
                <input type="text" v-model="username" placeholder="输入您的账号">
            </div>
            <div class="input-box">
                <input type="password" v-model="password" placeholder="输入您的密码">
            </div>
            <div class="input-box">
                <el-checkbox v-model="remember">记住密码</el-checkbox>
            </div>
            <div class="btn" @click="login">登录</div>
            <div class="tip">
                <div class="forget" @click="forgetPassword">忘记密码？</div>
            </div>
        </div>
     </div>
 </div>
</template>

<script>
    import {login} from '../../api/login.js'
    import {mapMutations} from 'vuex'
    export default {
        name: "login",
        data(){
            return{
                username:'',
                password:'',
                remember:false,
            }
        },
        mounted() {
            let user_info=JSON.parse(localStorage.getItem('user_info'))||'';
            if(user_info){
                this.username=user_info.username;
                this.password=user_info.password;
            }
        },
        methods:{
            ...mapMutations(['setToken','setRole']),
            login(){
                if(!this.username){
                    this.$message({
                        message: '请输入您的账号/电话号码',
                        type: 'warning'
                    });
                }
                if(!this.password){
                    this.$message({
                        message: '请输入您的密码',
                        type: 'warning'
                    });
                }

                login({
                    username:this.username,
                    password:this.password
                }).then(res=>{
                    if(res.code==1){
                        this.$message({
                            message: '登录成功',
                            type: 'success'
                        });
                        if(this.remember){
                            let obj={
                                username:this.username,
                                password:this.password
                            };
                            localStorage.setItem('user_info',JSON.stringify(obj));
                        }
                        this.setToken(res.data.token);
                        this.setRole(res.data.user_type);
                        window.localStorage.setItem('USERINFO',JSON.stringify(res.data));
                        window.localStorage.setItem('UTOKEN',res.data.token);
                        window.localStorage.setItem('ROLE',res.data.user_type);
                        this.$router.push({path: '/index'});
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                })
            },
            forgetPassword(){
                this.$router.push({path: '/forget'});
            },
        }
    }
</script>

<style scoped lang="scss">
.login{
    width: 100vw;
    height: 100vh;
    background: url(../../assets/images/bg.jpg) no-repeat;
    background-size: 100% 100%;
    .login-box{
        max-width: 600px;
        width: 45%;
        height: 450px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        box-shadow: 0 0 50px rgb(0,0,0,.5);
        .left-box{
            width: 50%;
            height: 100%;
            background: rgba(255,255,255,0.2);
            border-radius: 6px 0 0 6px;
            padding: 20px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .tit{
                font-size: 30px;
                color: #4890f7;
            }
            .av-txt{
                font-size: 20px;
                font-weight: bold;
                color: #4890f7;
            }
        }
        .right-box{
            width: 50%;
            height: 100%;
            background-color: #fff;
            padding: 30px 20px;
            border-radius: 0 6px 6px 0;
            .logo{
                width: 70px;
                height: 70px;
                margin:20px auto 50px auto;
                img{
                    width: 70px;
                    height: 70px;
                }
            }
            .input-box{
                width: 100%;
                height: 30px;
                background-color: #ffffff;
                margin-bottom: 30px;
                border-bottom: 1px solid #eaeaea;
                padding: 0 10px;
                text-align: left;
                input{
                    border: none;
                    background-color: #fff;
                    width: 100%;
                    outline:0px;
                }
            }
            .btn{
                width: 100%;
                height: 35px;
                border-radius: 30px;
                background-color: #4890f7;
                color: #ffffff;
                font-size: 16px;
                text-align: center;
                line-height: 35px;
                cursor: pointer;
            }
            .tip{
                margin-top: 10px;
                color: #999999;
                font-size: 14px;
                cursor: pointer;
                cursor: pointer;
            }
        }
    }
}
</style>
